/**
 * Delays the execution for a specified number of milliseconds.
 *
 * @param milliseconds - The number of milliseconds to delay.
 * @returns A promise that resolves after the specified delay.
 */
export const delay = async (milliseconds: number): Promise<void> => {
  await new Promise<void>((resolve) => setTimeout(() => resolve(), milliseconds));

  return;
};
